import React from 'react'
import { extractSpecificFields } from 'ducks/integrations/shared/settings'
import { Section, SectionLabel } from './Section'

import Properties from './Properties'

const companyPrioritizedFields = ['Name']

export default class Company extends React.PureComponent {
  render() {
    const { companyObject, settings, ownersById } = this.props

    const specificFields = extractSpecificFields(
      settings,
      /showSidebarField.Company\./
    )
    const shouldShow = companyObject && companyObject.state === 'fetched'
    if (!shouldShow) return null

    return (
      <Section>
        {shouldShow && (
          <div>
            <SectionLabel size="small" as="div">
              Company
            </SectionLabel>
            <Properties
              properties={companyObject.properties}
              prioritizedFields={companyPrioritizedFields}
              specificFields={specificFields}
              ownersById={ownersById}
            />
          </div>
        )}
      </Section>
    )
  }
}
